module.exports = __webpack_public_path__ + "static/media/bell-filled.18e6932c.svg";